/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Immature_FreshInputs */

const en_coach_immature_fresh = /** @type {(inputs: Coach_Immature_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness metrics are still stabilizing (less than 4 weeks of data). You appear well-rested based on early readings. Keep training consistently and the picture will sharpen over the coming weeks.`)
};

const de_coach_immature_fresh = /** @type {(inputs: Coach_Immature_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Werte pendeln sich noch ein — weniger als 4 Wochen Daten. Ersten Anzeichen nach bist du gut erholt. Trainiere weiter regelmäßig, das Bild wird bald klarer.`)
};

/**
* | output |
* | --- |
* | "Your fitness metrics are still stabilizing (less than 4 weeks of data). You appear well-rested based on early readings. Keep training consistently and the pi..." |
*
* @param {Coach_Immature_FreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_immature_fresh = /** @type {((inputs?: Coach_Immature_FreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Immature_FreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_immature_fresh(inputs)
	return de_coach_immature_fresh(inputs)
});